import UIAlert from 'common/uiutil.popup.src.js';
import UI from 'common/uiutil.for_iframe.js';
import env from 'common/env.js';
import wxBridge from 'jsbridge/jsbridge_login_queue';
import './intersectionObserver.js';

const wx = {};
wx.createSelectorQuery = function () {

  let dom = document;
  dom.in = function () {
      return dom;
  }
  dom.select = function (symbol) {
      let res = dom.querySelector(symbol);
      res.boundingClientRect = function (callback) {
          let bound = res.getBoundingClientRect();
          callback && callback(bound)
          return res;
      }
      res.exec = function () {

      }
      return res;
  }
  return dom;
}
wx.pageScrollTo = function (obj) {
  window.scrollTo({
      left: 0,
      top: obj.scrollTop,
      behavior: obj.duration ? 'smooth' : 'instant'
  })
}
wx.showModal = function (obj = {}) {
    obj.style = 'twoBtn';
    if(obj.showCancel === false) {
        obj.style = 'oneBtn';
    }
    if(obj.cancelText) {
        obj.closeTxt = obj.cancelText
    }
    if(obj.confirmText) {
        obj.confirmTxt = obj.confirmText
    }
    if(obj.success) {
        obj.confirmCb = () => {
            obj.success({confirm: true})
        }
        obj.closeCb = () => {
            obj.success({cancel: true})
        }
    }
    UIAlert.alert(obj.content, obj)
}
wx.showLoading = function (obj = {}) {
    UI.showLoading(obj.title || '加载中');
}
wx.hideLoading = function () {
    UI.hideLoading();
}
wx.showToast = function (obj) {
    UI.showTips(obj.title || '加载中', {
        type: obj.type || obj.icon || 'loading',
        timeout: obj.duration || 1000
    })
}
wx.getSystemInfoSync = function () {
    if(!env.isCSR) {
        return {
            windowWidth  : document.documentElement.clientWidth || document.body.clientWidth,
            windowHeight : document.documentElement.clientHeight || document.body.clientHeight,
            screenWidth  : screen.width,
            screenHeight : screen.height,
            isIos: env.isiOS
        }
    }else{
        return {
            windowWidth  : env.getCSR().getSystemInfo().windowWidth,
            windowHeight : env.getCSR().getSystemInfo().windowHeight,
            screenWidth  : env.getCSR().getSystemInfo().screenWidth,
            screenHeight : env.getCSR().getSystemInfo().screenHeight,
            isIos: false
        }
    }
}

wx.fixPage = function (flag, direction) {
    if(flag) {
        wx.lastWindowScroll = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = (-wx.lastWindowScroll) + 'px';
        document.body.style.left = '0px';
        document.body.style.right = '0px';
    }else {
        document.body.style.position = 'relative';
        document.body.style.top = 0;
        window.scrollTo(0, wx.lastWindowScroll);
    }
}

wx.createIntersectionObserver = function (node, {thresholds = [0], initalRatio = 0, observeAll = false} = {}) {
    let doc  = node.$el || document,
        _realCbk = null,
        _isFirstCbk = true,
        _cbk = (entries = []) => {
            const process = (entry) => {
                entry.relativeRect = entry.rootBounds;
                entry.dataset = entry.target.dataset;
                _realCbk && _realCbk(entry);
            }

            if(_isFirstCbk) {
                _isFirstCbk = false;
                entries.forEach((entry, index) => {
                    let intersectionRatio = entry.intersectionRatio;
                    if(intersectionRatio !== initalRatio) {
                        process(entry);
                        return;
                    }
                    thresholds.some(threshold => {
                        if(threshold === intersectionRatio) {
                            process(entry);
                            return true;
                        }
                    });
                });
            }else{
                entries.forEach((entry) => {
                    process(entry);
                })
            }
        },
        _intersectionObserver = null,
        _root = null;

    let observer = {
        disconnect() {
            _intersectionObserver.disconnect();
        },
        unobserve(target) {
            _intersectionObserver.unobserve(target);
        },
        relativeTo(selector, margins = {}) {
            _root = doc.querySelector(selector)
            _intersectionObserver = new IntersectionObserver(_cbk, {
                root       : _root,
                rootMargin : `${margins.top || 0}px ${margins.right || 0}px ${margins.bottom || 0}px ${margins.left || 0}px`,
                threshold  : thresholds
            })
            return observer;
        },
        relativeToViewport(margins = {}) {
            _root = null;
            _intersectionObserver = new IntersectionObserver(_cbk, {
                root       : _root,
                rootMargin : `${margins.top || 0}px ${margins.right || 0}px ${margins.bottom || 0}px ${margins.left || 0}px`,
                threshold  : thresholds
            })
            return observer;
        },
        observe(selector, cbk) {
            _realCbk = cbk;
            let observeNodes = null;

            if(typeof selector === 'string') {
                observeNodes = doc[observeAll ? 'querySelectorAll' : 'querySelector'](selector) || [];
            }else if(selector){
                observeNodes = selector || [];
            }
            if(observeNodes.length) {
                [].slice.call(observeNodes).forEach((node) => {
                    _intersectionObserver.observe(node);
                });
            }else if(observeNodes.length === 0) {
                console.warn('IntersectionObserver observe notFound elements');
            }else{
                _intersectionObserver.observe(observeNodes)
            }
            return observer;
        }
    }

    return observer;
}
wx.showModal = function (obj = {}) {
    obj.style = 'twoBtn';
    if(obj.showCancel === false) {
        obj.style = 'oneBtn';
    }
    if(obj.cancelText) {
        obj.closeTxt = obj.cancelText
    }
    if(obj.confirmText) {
        obj.confirmTxt = obj.confirmText
    }
    if(obj.success) {
        obj.confirmCb = () => {
            obj.success({confirm: true})
        }
        obj.closeCb = () => {
            obj.success({cancel: true})
        }
    }
    UIAlert.alert(obj.content, obj)
}

wx.getNetworkType = function (obj) {
    let res = env.getNetworkType();

    let map = {
        '0': 'wifi',
        '1': 'unknown',
        '2': '2g',
        '3': '3g',
        '4': '4g'
    }

    obj && obj.complete && obj.complete({
        networkType: map[res]
    })

    obj && obj.success && obj.success({
        networkType: map[res]
    })

    return {
        networkType: map[res]
    }
}
wx.previewImage = function (params = {}) {
    let current = params.current;
    let urls = params.urls;
    // let index = urls.findIndex

    wxBridge.invoke('imagePreview', {
        current: current,
        urls: urls
    })
}
export default wx;
